<button 
  matIconButton 
  [attr.aria-label]="'SAP Token Status'"
  [matTooltip]="getTooltip()"
  class="sap-token-button"
  (click)="generateSamlAssertion(true)">
  <mat-icon [style.color]="isTokenValid() ? '#2e7d32' : '#d32f2f'">{{ getIconName() }}</mat-icon>
</button>



<!-- <button
  matButton
  [attr.aria-label]="'SAP Token'"
  [matTooltip]="getTooltip()"
  class="sap-token-button"
>
  <mat-icon [color]="getIconColor()" [style.color]="isTokenValid() ? '#2e7d32' : null">{{ getIconName() }}</mat-icon>
  <span class="sap-token-button__label">SAP Token</span>
</button>
 -->